import { useEffect, useState } from 'react';
import { notification } from 'antd';

import {
  buildEligibilityTravelMethods,
  fetchTravelEligibility,
} from 'leash/utilities/travelEligibility/travelEligibility';
import { TravelMethod, TravelTypeIdType } from 'leash/types';
import { Address } from 'types';

function useEligibilityTravelMethod(
  travelTypeId: TravelTypeIdType,
  puppyId: number,
  address: Address,
): {
  eligibilityTravelMethods: TravelMethod[];
  loadingEligibilityTravelMethods: boolean;
} {
  const [eligibilityTravelMethods, setEligibilityTravelMethods] = useState<
    TravelMethod[]
  >([]);
  const [loadingEligibilityTravelMethods, setLoadingEligibilityTravelMethods] = useState(
    true,
  );

  useEffect(() => {
    fetchTravelEligibility(puppyId, address)
      .then((travelEligibility) => {
        const travelMethods = buildEligibilityTravelMethods(
          travelTypeId,
          travelEligibility,
        );

        setEligibilityTravelMethods(travelMethods);
        setLoadingEligibilityTravelMethods(false);
      })
      .catch((e) => notification.error({ message: e.message }));
  }, [travelTypeId, puppyId, address]);

  return {
    eligibilityTravelMethods,
    loadingEligibilityTravelMethods,
  };
}

export default useEligibilityTravelMethod;
